import React, { Component } from 'react';
import { Route } from "react-router-dom";
import SideBar from './SideBar';
import { _setTime } from './Function';
import LoanAccount from './Loan.Account';
import LoanTransaction from './Loan.Transaction';

class Loan extends Component {
    constructor() {
        super();
        this.state={ loadingShow: true };
    }

    onAddTime = () => { _setTime() }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <SideBar onRefresh={false} />
                <div className="content-bar">

                    <Route exact path="/online/loan" component={LoanAccount} />
                    <Route path="/online/loan/:id" component={LoanTransaction} />
                
                </div>
            </div>
        );
    }
}

export default Loan;